import { cn } from '@heidi/utils';
import type { ButtonProps, ButtonVariant } from '../button';

import type { ToastTone } from './toast.types';

/**
 * DS-1202 experimental ToastActionButton outline-toast recipe: the
 * warning coloured fill consumes the reworked `button-background-*`
 * component tier. Success/destructive delegate to Button variants (which
 * switch to their own experimental recipes under the same flag); the
 * solid-toast recipe is tone-agnostic and unchanged. Behind
 * `release-experimental-design-system-forms`.
 */
export const getOutlineActionButtonPropsExperimental = (
  tone: ToastTone
): Pick<ButtonProps, 'variant' | 'className'> & { variant: ButtonVariant } => {
  switch (tone) {
    case 'success':
      return { variant: 'success' };
    case 'destructive':
      return { variant: 'destructive' };
    case 'pro':
      return { variant: 'pro' };
    case 'practice':
      return { variant: 'pro_plus' };
    case 'warning':
      return {
        variant: 'default',
        className: cn(
          'bg-button-background-warning text-text-primary-invert',
          'hover:bg-button-background-warning-hover',
          'active:bg-button-background-warning-active'
        ),
      };
    default:
      return { variant: 'default' };
  }
};
